import Icon from '@chegg-wt/core/components/Icon'
import styled from 'styled-components'
import { SecondaryButton } from '@chegg-ui/button'
import { spacing, font, colors } from '@chegg-ui/theme'
import { adjust, themeBreakPoints } from '@chegg-wt/core/theme/theme'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: ${spacing.px8};
  @media (min-width: ${({ theme }) => adjust(themeBreakPoints.extraSmall(theme), 20)}) {
    justify-content: flex-end;
  }
`

const SubContainer = styled.div`
  display: flex;
  align-items: center;
`

export const AlertContainer = styled(SubContainer)`
  margin: ${spacing.px4} 0;
`

export const ButtonContainer = styled(SubContainer)``

export const ExclamationPoint = styled(Icon)`
  color: ${({ theme }) => theme.Colors.colorImportant};
  width: 20px;
`

export const Text = styled.p`
  ${AspiraStack};
  background: none;
  border: none;
  padding: 0;
  color: ${colors.link};
  text-decoration: none;
  font-size: ${font.size.px16};
  font-weight: ${font.weight.bold};
  letter-spacing: 0;
  line-height: ${font.lineHeight.sm};
  &:hover {
    text-decoration: underline;
  }
  font-size: ${font.size.px14};
  cursor: pointer;
`

export const IgnoreButton = styled(SecondaryButton).attrs({
  variant: 'outlined',
})`
  && {
    background-color: ${(props) => props.theme.colors.white};
    color: ${({ theme }) => theme.Colors.primaryColor};
    box-shadow: 0 0 0 0.125rem ${({ theme }) => theme.Colors.primaryColor} inset;
  }
  &&:hover {
    color: ${colors.white};
    background-color: ${({ theme }) => theme.Colors.primaryColor};
    box-shadow: 0 0 0 0.125rem ${({ theme }) => theme.Colors.primaryColor} inset;
  }
`
